import React, { useEffect, useState } from "react";
import { Row, Col, Card, Form, Button } from "react-bootstrap";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import {
  fetchAgencyById,
  createAgency,
  updateAgency,
} from "../../api/devTrainingTemplate";
import ClayButton from "@clayui/button";

const Detail = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);

  const [agencyDetails, setAgencyDetails] = useState({
    agencyName: "",
    phoneNumber: "",
    // yg bawah ni data hardcode, kalau takda kemungkinan error
    sectorId: "PS-ES",
    address1: "123",
    address2: "123",
    address3: "123",
    poscode: "123",
    city: "1600",
    state: "16",
    country: "MAS",
    cpdName: "test",
    cpdEmail: "test@email",
    cpdPhoneNumber: "123",
    loginId: "test@email",
    status: "DRAFT",
    manualSubmission: false,
    installedCapacity: false,
    powerPlantPerformance: false,
    netCalorificValue: false,
    c1CheckBox: false,
  });

  const isEdit = !!id && !queryParams.get("viewOnly");
  const viewOnly = queryParams.get("viewOnly") === "true";
  const isCreate = !id;

  useEffect(() => {
    if (id) {
      fetchAgencyDetails();
    }
  }, [id]);

  const fetchAgencyDetails = async () => {
    try {
      const result = await fetchAgencyById(id);
      setAgencyDetails(result);
    } catch (error) {
      console.error("Error fetching agency detail:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAgencyDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEdit) {
        await updateAgency(id, agencyDetails);
        alert("Agency updated successfully");
      } else {
        await createAgency(agencyDetails);
        alert("Agency created successfully");
      }
      navigate("/agency-list");
    } catch (error) {
      alert("Error saving agency");
    }
  };

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h4>
          {isCreate
            ? "Create New Agency"
            : viewOnly
            ? "Agency Details"
            : "Edit Agency"}
        </h4>
        {viewOnly && (
          <ClayButton
            displayType="primary"
            onClick={() => navigate(`/agencyDetailTest/${agencyDetails.id}`)}
          >
            Edit Agency
          </ClayButton>
        )}
      </div>
      <div className="card-body">
        <Form onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Col sm={6}>
              <Form.Label>
                <strong>AGENCY NAME</strong>
              </Form.Label>
              <Form.Control
                type="text"
                name="agencyName"
                value={agencyDetails.agencyName}
                onChange={handleChange}
                disabled={viewOnly}
                required
              />
            </Col>
            <Col sm={6}>
              <Form.Label>
                <strong>AGENCY PHONE NUMBER</strong>
              </Form.Label>
              <Form.Control
                type="text"
                name="phoneNumber"
                value={agencyDetails.phoneNumber}
                onChange={handleChange}
                disabled={viewOnly}
                required
              />
            </Col>
          </Row>
          {!viewOnly && (
            <Button type="submit" variant="primary">
              {isCreate ? "Save" : "Update"}
            </Button>
          )}
        </Form>
      </div>
    </div>
  );
};

export default Detail;
